<template>
  <div class="steps">
    <header class="d-flex">
      <a :href="lpUrl" target="blank" class="left">
        <i class="ico-iouu logotipo" aria-hidden="true"></i>
      </a>
      <img src="../../assets/images/liza.jpg" alt="Foto Liza">
      <a href="#" class="right c1" v-on:click='Home' title="Ir para Home" style=" right: 90px; !important">
        <i class="ico-home"></i> Ir para Home
      </a>
      <a href="#" class="right" v-on:click='Logout' title="Sair">
        <i class="ico-exit"></i> Sair
      </a>
    </header>    
    <main class="container">
     <router-view  />
    </main>
  </div>
</template>

<script>
  /* eslint-disable */
    import * as mutationTypes from '@/store/mutation-types.js'
  export default {
    data() {
      return{
        lpUrl:process.env.LP_URL
      }
    },
    methods: {
      Logout() {
       this.$store.dispatch('logout')
       this.$router.push('/login')
     },
      Home() {
       sessionStorage.removeItem("redirectINV");
       this.$router.push('/investimentos/meus-investimentos')
     }
   }, beforeCreate() {

      window.document.title= 'Dashboard IOUU';
   }
}
</script>



// WEBPACK FOOTER //
// src/views/layouts/AdditionalInformationLayout.vue